<template>
    <div class="widget-item">
        <subscribe :show_title="false" :show_description="false" :compact="true"></subscribe>
    </div>
</template>

<script>
  import Subscribe from '@/components/home/Subscribe.vue';
  export default {
    components: {
      Subscribe
    },
    data () {
      return {}
    }
  }
</script>
